import { defineStore } from 'pinia'

export const usePlaySessionStore = defineStore(
  '_cam_play_session',
  () => {
    const sessionId = ref<string>('')

    const setSessionId = (newSessionId: string): void => {
      // console.log('setSessionId', newSessionId)
      sessionId.value = newSessionId
    }
    const resetSessionId = (): void => {
      sessionId.value = ''
    }

    return {
      sessionId,
      setSessionId,
      resetSessionId,
    }
  },
  {
    // localStorage で永続化する (#596 — authInfo.ts のコメント参照)。
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
    },
  },
)
